import { RepintelSignalsEnum } from '../enums';
import { RepIntelCountersResponseDto } from '../dto';

export const RepintelSignalKeysAssocConst: Record<RepintelSignalsEnum, keyof RepIntelCountersResponseDto> = {
  [RepintelSignalsEnum.BOMBORA_INTENT]: 'bombora_intent',
  [RepintelSignalsEnum.PREDICTIVE_INTENT]: 'predictive_intent',
  [RepintelSignalsEnum.VISITOR_INTEL]: 'visitor_intel',
  [RepintelSignalsEnum.NEW_LEADERSHIP]: 'new_leadership',
}
